import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Snowflake = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M22 11.4512H17.83L21.07 8.21117L19.66 6.79117L15 11.4512H13V9.45117L17.66 4.79117L16.24 3.38117L13 6.62117V2.45117H11V6.62117L7.76 3.38117L6.34 4.79117L11 9.45117V11.4512H9L4.34 6.79117L2.93 8.21117L6.17 11.4512H2V13.4512H6.17L2.93 16.6912L4.34 18.1112L9 13.4512H11V15.4512L6.34 20.1112L7.76 21.5212L11 18.2812V22.4512H13V18.2812L16.24 21.5212L17.66 20.1112L13 15.4512V13.4512H15L19.66 18.1112L21.07 16.6912L17.83 13.4512H22V11.4512Z"
    />
  </svg>
);
